import { colors, fonts} from 'theme'
import { fontSizes } from 'theme/fonts'
import css from 'styled-jsx/css'

export default css`
  .form-container {
    display: flex;
    flex-direction: column;
    max-width: 540px;
    width: 100%;
    padding: 1rem;
  }

  h4 {
    font: ${fonts.semiBold};
    font-size: ${fontSizes.h4};
    text-align: left;
    color: ${colors.text};
    margin: 0px;
  }

  .legend {
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 14px;
    text-align: left;
    color: ${colors.lightText};
    margin: 10px 0px;
  }

  .form-container :global(.actions) {
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .form-container :global(.submit) {
    margin: 10px 0;
  }

  .buttons-container {
    padding: 1rem;
  }
`

export const participantsStyle = css`
  .participants {
    display: flex;
    flex-wrap: wrap;
  }
  .participants p{
    padding: 0 .3rem;
    margin: .3rem 0;
  }
`

